import React from 'react';
import { Button, Popconfirm } from 'antd';

export interface BlockAccountButtonProps {
  isBlocked: boolean;
  isLoading: boolean;
  onBlock: () => void;
  onUnblock: () => void;
}

const BlockAccountButton: React.FC<BlockAccountButtonProps> = ({ isBlocked, isLoading, onBlock, onUnblock }) => {
  const buttonText = isBlocked ? 'Unblock Account' : 'Block Account';
  const buttonType = isBlocked ? 'primary' : 'danger';
  const buttonIcon = isBlocked ? 'unlock' : 'lock';
  const confirmText =
    'This action will change the account status. Are you sure you want to proceed?';
  const onConfirm = isBlocked ? onUnblock : onBlock;

  return (
    <Popconfirm
      key="confirm"
      title={confirmText}
      onConfirm={onConfirm}
      okText="Yes"
      cancelText="No"
    >
      <Button
        key="blockAccountButton"
        type={buttonType}
        shape="round"
        size="small"
        icon={buttonIcon}
        className="ml4"
        loading={isLoading}
      >
        {buttonText}
      </Button>
    </Popconfirm>
  );
};

export default BlockAccountButton;
